import { createApi } from "@reduxjs/toolkit/query/react";
import { xeroAxiosQuery } from "../../utils/axios/xero.axios";


export const xeroAPI = createApi({
    reducerPath: "xeroApi",
    baseQuery: xeroAxiosQuery(),
    tagTypes: ["xero", "token"],
    endpoints: (builder) => ({
        getXeroTokenFromCode: builder.mutation({
            query: (code) => ({
                url: `/xero/callback?code=${code}`,
                method: "GET",
            }),
        }),
        getXeroCredentials: builder.query<{ accessToken: string; refreshToken: string }, void>({
            query: () => ({
                url: "/xero/credentials",
                method: 'GET'
            })
        }),
        logoutXero: builder.mutation<void, void>({
            query: () => ({
                url: "/xero/logout",
                method: "POST",
                data: {}
            }),
            invalidatesTags: ['token']
        }),
    }),
});

export const {
    useGetXeroCredentialsQuery,
    useLogoutXeroMutation,
    useGetXeroTokenFromCodeMutation
} = xeroAPI;